import Decorator from './decorator'

export default class WeighbridgeDecorator extends Decorator {
  /**
   * The status text corrosponding to each status.
   *
   * @return string
   */
  statusText () {
    if (this.decorated.status === 'pending') {
      return 'Pending'
    } else if (this.decorated.status === 'part_approved') {
      return 'Part-Approved'
    } else if (this.decorated.status === 'resubmit') {
      return 'Resubmit'
    } else if (this.decorated.status === 'approved') {
      return 'Approved'
    }

    return '–'
  }

  /**
   * The status class corrosponding to each status.
   *
   * @return string
   */
  statusClass () {
    if (this.decorated.status === 'pending') {
      return 'text-info'
    } else if (this.decorated.status === 'part_approved') {
      return 'text-info'
    } else if (this.decorated.status === 'resubmit') {
      return 'text-danger'
    } else if (this.decorated.status === 'approved') {
      return 'text-success'
    }

    return 'text-primary'
  }
}



// WEBPACK FOOTER //
// ./src/decorators/weighbridge.js